export const getRoute = (locale: string, baseRoute: string | undefined, slug: string | undefined, anchor: string | undefined, useLegacyDigitalPlatformRoutes?: boolean) => {
  if (!baseRoute) return `/${locale}${anchor ? `#${anchor}` : ''}`;

  const legacyDigitalPlatformRoutes = ['products', 'brands', 'case-studies', 'producers'];

  // HACK: This is a temporary fix to route to the Angular app
  if (useLegacyDigitalPlatformRoutes && legacyDigitalPlatformRoutes.includes(baseRoute)) {
    const language = locale.split('-')[0].toLowerCase();

    if (slug) {
      if (slug.startsWith('?')) {
        return `/${language}/${baseRoute}${slug}${anchor ? `#${anchor}` : ''}`;
      }
      return `/${language}/${baseRoute}/${slug}${anchor ? `#${anchor}` : ''}`;
    }
    return `/${language}/${baseRoute}${anchor ? `#${anchor}` : ''}`;
  }

  if (slug) {
    if (slug.startsWith('?')) {
      return `/${locale}/${baseRoute}${slug}${anchor ? `#${anchor}` : ''}`;
    }

    const route = baseRoute.replace(':slug', slug);
    return `/${locale}/${route}${anchor ? `#${anchor}` : ''}`;
  }

  return `/${locale}/${baseRoute}${anchor ? `#${anchor}` : ''}`;
};

export const getRouteParameter = (routeParams?: { [key: string]: string }): string | undefined => {
  if (routeParams?.orderId) {
    return routeParams.orderId;
  }
  if (routeParams?.shipmentId) {
    return routeParams.shipmentId;
  }
  return undefined;
};
